import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '@kontentino/react-permissions-gate';
import { UserPermission } from 'constants/userPermission';
import { addQueryParams, openBlank } from 'utils/url';
import { modalRoutes } from 'constants/routes';
import { useSocialLoginContext } from 'app/modules/socialLogin/context';
import { useUser } from 'modules/user/userSelector';
import { buildAnalyticsManageProfileGroupSearch } from 'app/modules/analytics/utils/buildAnalyticsManageProfileGroupSearch';

const useAnalyticsProfileOptionActions = () => {
  const navigate = useNavigate();
  const socialLogin = useSocialLoginContext();
  const { permissionsKeys } = useUser();

  const handleEditProfileGroupClick = useCallback(
    (id: number) => {
      navigate({
        hash: modalRoutes.MANAGE_PROFILE_GROUP,
        search: buildAnalyticsManageProfileGroupSearch(id),
      });
    },
    [navigate],
  );

  const handleEditProfileClick = useCallback(
    (id: number, isGlobal?: boolean) => {
      isGlobal
        ? openBlank(`/Projects/Pages/page:${id}/type:global`)
        : openBlank(`/Projects/Pages/page:${id}/type:my`);
    },
    [],
  );

  const canEditProfile = useCallback(
    (isDemo: boolean = false) => {
      return (
        hasPermission(permissionsKeys, UserPermission.PAGE_EDIT) && !isDemo
      );
    },
    [permissionsKeys],
  );

  const canEditProfileGroup = useCallback(
    (isEditable: boolean = false) => {
      return (
        isEditable &&
        hasPermission(permissionsKeys, UserPermission.PAGE_PRESETS_MANAGE)
      );
    },
    [permissionsKeys],
  );

  const handleConnectionClick = useCallback(
    (page: { id: number; type: number | null }) => {
      if (page.type) {
        socialLogin.authorize({
          pageId: page.id,
          pageType: page.type,
          redirectUrl: `${addQueryParams(window.location.href, {
            ...page,
            reconnect: 1,
          })}#${modalRoutes.ASSOCIATE_POSTS_PROFILE}`,
        });
      }
    },
    [socialLogin],
  );

  return {
    handleEditProfileGroupClick,
    handleEditProfileClick,
    canEditProfile,
    canEditProfileGroup,
    handleConnectionClick,
  };
};

export default useAnalyticsProfileOptionActions;
